module.exports = __webpack_public_path__ + "img/occupation-cart-head-4.89f22404.png";